/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListReservationsV2Request {
    getFixupPrototypeFunction() { return ListReservationsV2Request.fixupPrototype; }

    static newInstance(model: Partial<ListReservationsV2Request>): ListReservationsV2Request {
        let obj = Object.assign(new ListReservationsV2Request(), model);
        ListReservationsV2Request.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListReservationsV2Request>): ListReservationsV2Request {
        if (!model) return null;
        return ListReservationsV2Request.newInstance(<ListReservationsV2Request> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListReservationsV2Request) {
        if (!obj) return;

        models.ListReservationsV2Request.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListReservationsV2Request): boolean {
        Object.setPrototypeOf(obj, ListReservationsV2Request.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Date Filter to select
     */
    date_filter: models.DashboardDateFilter;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

    /**
     * cloud service name
     */
    service: models.CloudServiceName;

    /**
     * One or more tenant IDs to fetch reservations across. Omit to scope to a single tenant.
     */
    tenant_ids: Array<string>;

}
